import React, { useEffect, useState } from 'react';

import {
  AutocompleteFieldFreeSolo,
  InputField,
  RadioGroupField,
} from "../../../../components/FormFields";
import { useStateAuthValue } from "../../../../context/Auth/AuthState";
// Comentado hasta que se habiliten todas las especialidades
/* import { GetSpecialties } from '../../../../services/userService';
import { showToast, ToastType } from '../../../../utils/ToastUtil';
import { useToast } from '../../../../context/Toast/ToastProvider'; */
import licenceTypes from "../../../../tests/mocks/licenceTypes";

const ProfessionalDataForm = ({ formModel }) => {
   const {
      professional_dto: {
         licence_str,
         type_licence_str,
         specialties,
         academic_training,
      },
   } = formModel;
   
   const [{ userToken }] = useStateAuthValue();
   // Comentado hasta que se habiliten todas las especialidades
   // const toastDispatch = useToast();
   const [specialtiesList, setSpecialtiesList] = useState([]);
   
   useEffect(() => {
      // Comentado hasta que se habiliten todas las especialidades
      // let isMounted = true;
      // const getData = async () => {
      const getData = () => {
         setSpecialtiesList([
            {
               id: "411c8728-6c6e-44c0-8fb4-a3997d329a22",
               name: "Veterinario",
            },
         ]);
      }; 

    if (userToken) {
      getData();
    }

    // Comentado hasta que se habiliten todas las especialidades
    return () => {
      // isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken]);

  return (
    <>
      <div className="header">
        <h2>Datos Profesionales</h2>
      </div>
      <div className="form">
        <InputField
          name={licence_str.name}
          label={licence_str.label}
          className="field"
          requiredField
          maxLength={10}
        />
        <RadioGroupField
          name={type_licence_str.name}
          label={type_licence_str.label}
          data={licenceTypes}
          className="field"
          requiredField
        />
        <AutocompleteFieldFreeSolo
          name={specialties.name}
          label={specialties.label}
          options={specialtiesList}
          className="field"
          requiredField
          placeholder={specialties.placeholder}
        />
        <InputField
          name={academic_training.name}
          label={academic_training.label}
          className="field"
          rows={3}
          requiredField
          maxLength={255}
        />
      </div>
    </>
  );
};

export default ProfessionalDataForm;
